export const SERVICE_LINKS = {
  'bznav-care': 'https://ac.bznav.com/ebzpik',
  'bznav-plus': 'https://plus.bznav.com/calc?utm_source=bznav.homepage&utm_campaign=bznav_homepage_to_plus&utm_medium=organic&utm_content=nav_menu_click',
  'bznav-refund': 'https://ab.bznav.com/teslan',
  'bznav-sena': 'https://ai.bznav.com/?utm_source=bznav.homepage&utm_campaign=bznav_homepage_to_sena&utm_medium=organic&utm_content=nav_menu_click'
};
